import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=15674b6a"
import script from "./MainSettings.vue?vue&type=script&lang=ts"
export * from "./MainSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports